<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="toc1"><a id="page_vii"></a><a href="#/xhtml/08_Acknowledgement"><i>Acknowledgments</i></a></p>
<p class="toc1b"><a href="#/xhtml/09_FM02"><i>Note on Transliteration and Translation</i></a></p>
<p class="toc1"><a href="#/xhtml/11_Introduction">Introduction</a></p>
<p class="toc"><span href="#/xhtml/12_Chapter01" title="Link target outside of Sample">1   <i>Mente</i>: Consumer Grievances</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter02" title="Link target outside of Sample">2   Needs, Rights, and Protection</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3   Consumer Activism?</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample">4   Consumption as Civic Engagement</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter05" title="Link target outside of Sample">5   Consumer Politics after State Socialism</span></p>
<p class="toc1b"><span href="#/xhtml/17_Epilogue" title="Link target outside of Sample">Epilogue: “Enough Is Enough”—The Moral Commitment of the State</span></p>
<p class="toc1"><span href="#/xhtml/18_Appendix01" title="Link target outside of Sample"><i>Appendix. An East Asian Ethnographer in Eastern Europe: Notes on Fieldwork and Positionality</i></span></p>
<p class="toc1"><span href="#/xhtml/19_Reference" title="Link target outside of Sample"><i>References</i></span></p>
<p class="toc1"><span href="#/xhtml/20_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?1478b216